import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_card_consumption_records',
  component: Management,
  redirect: '/charging_card_consumption_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charging_card_consumption_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargingCardConsumptionRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charging_card_consumption_records/ListTable'),
          meta: {
            auth: Auth.listChargingCardConsumptionRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
